'use client'

import { usePathname } from 'next/navigation'
import { Suspense, type ReactNode } from 'react'

export function ConditionalHeaderFooter({
  header,
  footer,
}: {
  header: ReactNode
  footer: ReactNode
}) {
  return (
    <>
      <Suspense fallback={null}>{header}</Suspense>
      {footer}
    </>
  )
}

export function ConditionalHeader({ header }: { header: ReactNode }) {
  return <Suspense fallback={null}>{header}</Suspense>
}

/**
 * Explanation pages omit the site footer.
 */
export function ConditionalFooter({ footer }: { footer: ReactNode }) {
  const pathname = usePathname()
  if (pathname?.startsWith('/explanation')) {
    return null
  }

  return <>{footer}</>
}
